import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import {SIDE_BAR} from "../side-bar-module.consts";
import {runInAction} from "mobx";

export class SideBarModuleTabClickHandler extends ActionHandler {
  analyticsService: AnalyticsService;
  type = SIDE_BAR.ACTION_TYPES.onTabClick;

  static injectables = [AnalyticsService];

  action(params) {
    runInAction(() => {
      this.state.selectedTabIndex = params.index
    })
  }
}
